"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Separa un string a un path de Firestore en el nombre del documento y el path,
 * útil para usar con collection y doc
 *
 * @param path path a separar
 * @example
 * A = getSplitPath(/user/asd123)
 * A
 * [/user, /asd123]
 * @returns {[string, string]} [path, document]
 */
function getSplitPath(path) {
    const docId = path.split("/")[-1];
    const collection = path.replace(docId, "");
    return [collection, docId];
}
exports.default = getSplitPath;
